var _path, _path2, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6017 4.74805L31.3517 14.498V33.998C31.3517 35.075 30.4786 35.948 29.4017 35.948H9.90166C8.8247 35.948 7.95166 35.075 7.95166 33.998V6.69805C7.95166 5.62109 8.8247 4.74805 9.90166 4.74805H21.6017ZM19.6517 6.69805H9.90166V33.998H29.4017V16.448H21.6017C20.5247 16.448 19.6517 15.575 19.6517 14.498V6.69805ZM21.6017 7.5073L28.5944 14.498H21.6017V7.5073Z",
    fill: "var(--header-text-color)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2891 12.8135C15.3905 12.8135 16.2834 13.7064 16.2834 14.8078V15.6056H11.4971V14.8078C11.4971 13.7064 12.39 12.8135 13.4914 12.8135H14.2891ZM13.8903 10.0215C14.5511 10.0215 15.0868 10.5572 15.0868 11.2181C15.0868 11.8789 14.5511 12.4147 13.8903 12.4147C13.2294 12.4147 12.6937 11.8789 12.6937 11.2181C12.6937 10.5572 13.2294 10.0215 13.8903 10.0215Z",
    fill: "var(--main-color)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.6748,
    y: 18.5752,
    width: 15.9545,
    height: 2.65909,
    fill: "var(--main-color)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6748,
    y: 23.0068,
    width: 13.2955,
    height: 2.65909,
    fill: "var(--main-color)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6748,
    y: 27.4385,
    width: 9.75,
    height: 2.65909,
    fill: "var(--main-color)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactInfo);
export default __webpack_public_path__ + "static/media/contact-info.c2e6faf7.svg";
export { ForwardRef as ReactComponent };